class CollectionSearch {
  constructor() {
    this.searchInput = document.querySelector('.dwn-search-bar__container input');
    this.productGrid = document.getElementById('product-grid');
    this.productGridContainer = document.getElementById('ProductGridContainer');
    this.searchTimeout = null;
    this.allProducts = [];
    this.noResultsMessage = null;
    
    if (this.searchInput && this.productGrid) {
      this.init();
    }
  }

  init() {
    // Store all product items
    this.allProducts = Array.from(this.productGrid.querySelectorAll('.grid__item'));
    
    // Create a no results message element
    this.createNoResultsMessage();
    
    // Add event listener to search input
    this.searchInput.addEventListener('input', this.handleSearch.bind(this));
    
    console.log('Collection search initialized with', this.allProducts.length, 'products');
  }

  createNoResultsMessage() {
    this.noResultsMessage = document.createElement('div');
    this.noResultsMessage.className = 'collection-search-no-results';
    this.noResultsMessage.style.display = 'none';
    this.noResultsMessage.style.padding = '4rem 2rem';
    this.noResultsMessage.style.textAlign = 'center';
    this.noResultsMessage.style.gridColumn = '1 / -1';
    this.noResultsMessage.innerHTML = `
      <h2 style="font-size: 2rem; margin-bottom: 1rem;">No products found</h2>
      <p style="font-size: 1.4rem; color: rgba(var(--color-foreground), 0.75);">
        Try adjusting your search terms
      </p>
    `;
    this.productGrid.appendChild(this.noResultsMessage);
  }

  handleSearch(event) {
    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    const searchTerm = event.target.value.trim();

    // Debounce search by 300ms
    this.searchTimeout = setTimeout(() => {
      this.performSearch(searchTerm);
    }, 300);
  }

  performSearch(searchTerm) {
    console.log('Searching for:', searchTerm);
    
    const term = searchTerm.toLowerCase();
    let visibleCount = 0;

    // Filter products
    this.allProducts.forEach((product, index) => {
      // Get product title from various possible selectors
      const titleElement = product.querySelector('.card__heading a, .card-title, .card__information h3, h3.card__heading');
      const productTitle = titleElement ? titleElement.textContent.trim().toLowerCase() : '';
      
      // Check if product matches search term
      const matches = !term || productTitle.includes(term);
      
      if (matches) {
        product.style.display = '';
        // Reset animation order for visible products
        if (product.hasAttribute('data-cascade')) {
          product.style.setProperty('--animation-order', visibleCount + 1);
        }
        visibleCount++;
      } else {
        product.style.display = 'none';
      }
    });

    // Show/hide no results message
    if (visibleCount === 0 && term) {
      this.noResultsMessage.style.display = 'block';
    } else {
      this.noResultsMessage.style.display = 'none';
    }

    // Update product count
    this.updateProductCount(visibleCount);
    
    console.log('Found', visibleCount, 'matching products');
  }

  updateProductCount(count) {
    // Update mobile product count
    const productCount = document.getElementById('ProductCount');
    if (productCount) {
      if (count === this.allProducts.length) {
        productCount.textContent = `${count} products`;
      } else {
        productCount.textContent = `Showing ${count} of ${this.allProducts.length} products`;
      }
    }

    // Update desktop product count
    const productCountDesktop = document.getElementById('ProductCountDesktop');
    if (productCountDesktop) {
      if (count === this.allProducts.length) {
        productCountDesktop.textContent = `${count} products`;
      } else {
        productCountDesktop.textContent = `Showing ${count} of ${this.allProducts.length} products`;
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionSearch();
  });
} else {
  new CollectionSearch();
}

